export default "__VITE_ASSET__qpLR$nX___"